import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { SpacingValue } from "web/react/emo/theme.css";
import * as styles from "./verified-badge.css";

const SIZES = {
    xs: "12px",
    sm: "16px",
};

export function VerifiedBadge({ size = "xs" }: { size?: SpacingValue }): React.ReactElement {
    return (
        <SVGIcon
            dataTestId="verified-badge"
            style={assignInlineVars({ [styles.size]: SIZES[size] })}
            className={styles.badge}
            name="verified"
        />
    );
}
